const MacronizeButton = ({macronize}) => {
    return (  
        <div className="macronize-button">
            <button onClick={macronize}>macronize</button>
        </div>
    );
}
 
export default MacronizeButton;